import styled from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const LoadingStepContainer = styled.div<{
  visible: boolean;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${SPACING._16};
  text-align: center;
  transition: 200ms;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  pointer-events: ${({ visible }) => (visible ? 'all' : 'none')};
`;
